import { atom } from 'recoil';

export interface PriceSummary {
  accountId: string;
  currency: string;
  fiscalYearToDateAmount: string;
  currentMonthToDateAmount: string;
}

export const priceSummaryState = atom<PriceSummary | null>({
  key: 'priceSummaryState',
  default: null,
});

export const priceSummaryLoadingState = atom<boolean>({
  key: 'priceSummaryLoadingState',
  default: true,
});

export const priceSummaryErrorState = atom<string>({
  key: 'priceSummaryErrorState',
  default: '',
});
